const initialState = {
  access: null
}

const access = (state = initialState, action) => {
  switch (action.type) {
    case "ACCESS":
      return { ...state, access: action.val }
    default:
      return state
  }
}
export default access
